import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
// TODO: https://github.com/mui/mui-x/issues/4644
import { DesktopDatePicker, DesktopDateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { isoDateOnlyGen } from '#component/project/form/helper';
import { getDateTimeFormat } from '#helper';

/**
 * Renders keyboard date time picker.

 * @returns {React.FC}
 */

const DateTimeField = props => {
  const measurementSystem = useSelector(s => s.account.measurementSystem);
  const {
    minDate,
    maxDate,
    disabled,
    dateonly,
    forceError,
    label,
    fullWidth,
    variant,
    className,
    info
  } = props;

  const input = props.input || {
    onBlur: props.onBlur,
    onChange: props.onChange,
    value: props.value,
    name: props.name
  };
  const { onBlur: inputOnBlur, value, ...inputProps } = input;
  const meta = props.meta || {};
  const isTouched = Boolean(
    meta.touched || meta.isTouched || meta.isSubmitted || meta.submitFailed
  );
  const invalid = Boolean(meta.invalid || meta.error);
  const rawError = meta.error || props.error;
  const errorMessage = typeof rawError === 'object' ? rawError?.message : rawError;

  const format = useMemo(() => getDateTimeFormat(measurementSystem, dateonly ? 'dateOnly' : 'dateTimeShortDateFns'), [measurementSystem, dateonly]);

  const onChange = date => {
    if (Date.parse(date)) {
      if (dateonly) inputProps.onChange?.(isoDateOnlyGen(date));
      else inputProps.onChange?.(date.toISOString());
    } else if (date === null) {
      inputProps.onChange?.(null);
    } else {
      inputProps.onChange?.(new Date(''));
    }
  };

  const onBlur = () => {
    if (dateonly) inputOnBlur?.(Date.parse(value) ? value : null);
    else inputOnBlur?.(Date.parse(value) ? new Date(value).toISOString() : null);
  };

  const dateProps = {
    label,
    value: value ? new Date(value) : null,
    minDate: minDate ? new Date(minDate) : undefined,
    maxDate: maxDate ? new Date(maxDate) : undefined,
    onChange,
    disabled: meta.submitting || disabled,
    format,
    className,
    slotProps: {
      textField: {
        fullWidth,
        variant,
        helperText: (isTouched || forceError) && errorMessage ? errorMessage : info,
        error: Boolean((isTouched || forceError) && invalid),
        onBlur
      }
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {dateonly ? (
        <DesktopDatePicker {...dateProps} />
      ) : (
        <DesktopDateTimePicker {...dateProps} />
      )}
    </LocalizationProvider>
  );
};

export default DateTimeField;
